<template>
  <div class="home">
    <loginForm :msg="msg" />
  </div>
</template>

<script>
// @ is an alias to /src
import loginForm from "@/components/auth/loginForm.vue";

export default {
  name: "login",
  data() {
    return {
      msg: this.$route.params.ref || "null"
    };
  },
  components: {
    loginForm
  }
};
</script>
